import React, { useState } from "react";
import { useSelector } from "react-redux";
import store from "../../Redux/Store";
import { BiPlus } from "react-icons/bi";

const Buttonbox = ({
  handleClick,
  text,
  removeIcon,
  className,
  type = "button",
}) => {
  const { appType } = store.getState().uiReducers;
  return (
    <button
      onClick={handleClick}
      class={`btn btn-theme  ${className}   bg-gradient`}
      type={type}
      data-bs-theme={appType}
    >
      {!removeIcon && <BiPlus className=" fs-7" />}
      {removeIcon && <span class="me-1">{removeIcon}</span>}
      {text}
    </button>
  );
};

export default Buttonbox;
